export const CountryEnum={
    INDIA:"INDIA",
    India: "India",
};